import axios from 'axios';
import store from '../store';
import router from './../router';
axios.interceptors.request.use((config) => {
    config.baseURL = process.env.VUE_APP_SHOPWARE_SALES_CHANNEL_API_BASE_URL;
    let swAccessKey = process.env.VUE_APP_SW_ACCESS_KEY;
    config.headers = { 'sw-access-key': swAccessKey };
    if (store.getters['auth/isAuthenticated']) {
        // Add token
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});
axios.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (error.response.status === 403 || error.response.status === 401) {
        router.push({ name: 'auth_logout' });
    }
    return Promise.reject(error);
});
export default axios;
//# sourceMappingURL=http.js.map
